import { useProperty, useTranslation } from '@eti/providers';
import { Notice, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { useRef } from 'react';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { PLATINUM_SERVICE } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps, getModal } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { standardGrid } from '../../common/main-layout/illustration/styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = PLATINUM_SERVICE;
const generalTexts = {
  additionalInformation: 'platinumAdditionalInformation',
  persuasionContent: 'platinumPersuasionContent',
  readMoreContent: 'platinumReadMoreModalContent',
  description: 'platinumAbstract',
  title: 'platinumTitle',
  upSell: 'platinumUpSell'
};
const promotionalTextStyle = css`
  margin-top: 16px;
`;
const customGrid = css`
  ${standardGrid}

  .canvas {
    [dir='rtl'] & {
      transform: unset;
    }
  }
`;
const MainPlatinum = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    form,
    platinumPriceLabel,
    isSelected,
    order,
    productPosition
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const translation = getTranslatedTexts(generalTexts, t);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    price
  } = getPriceProps(t, isSelected, product);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, '', translation.persuasionContent);
  const {
    additionalInformation,
    description,
    readMoreContent,
    title
  } = translation;
  const promotionalText = t('platinumPromotionalText');
  const productData = {
    additionalInformation,
    extraProps,
    description,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel: platinumPriceLabel,
    priceRaw,
    productCardModal,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreContent,
    shouldDisplayUpsell,
    readMoreButtonLabel,
    title,
    travelers: order.travelers,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: productData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.Illustration, {
      customGrid: customGrid
    }), /*#__PURE__*/_jsx(ProductLayout.Body, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: promotionalText && /*#__PURE__*/_jsx(Notice, {
          className: promotionalTextStyle,
          variant: "promotional",
          children: /*#__PURE__*/_jsx(Text, {
            asHtml: true,
            variant: textVariants._14_BOLD,
            children: promotionalText
          })
        })
      })
    })]
  });
};
export default MainPlatinum;